import React, { useState } from "react";
// import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "./style.css";
import {
  Form,
  Select,
  InputNumber,
  Button,
  Upload,
  Input,
  Typography,
} from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import { riderAdd } from "../../../services/riders.service";
import { validationErrors } from "../../../utils/Helpers";
import { swalNotification } from "../../../components/alret/notificztion";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;
const { Option } = Select;
const formItemLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 14,
  },
};

const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
};

const RiderAdd = () => {
  const navigate = useNavigate();
  const [MBtnLoading, setMBtnLoading] = useState(false);

  const pagename = "Add Rider";
  const onFinish = async (values) => {
    // if (values.profileImage === undefined) {
    //   swalNotification(
    //     "Validation Error",
    //     "Profile Image is Required",
    //     "error"
    //   );
    //   return null;
    // } else {
    //   values.profileImage = values.profileImage[0].originFileObj;
    // }
    if (values.bill === undefined) {
      swalNotification("Validation Error", "Bill Image is Required", "error");
      return null;
    } else {
      values.bill = values.bill[0].originFileObj;
    }
    if (values.cnicFront === undefined) {
      swalNotification(
        "Validation Error",
        "CNIC Front Image is Required",
        "error"
      );
      return null;
    } else {
      values.cnicFront = values.cnicFront[0].originFileObj;
    }
    if (values.cnicBack === undefined) {
      swalNotification(
        "Validation Error",
        "CNIC Back Image is Required",
        "error"
      );
      return null;
    } else {
      values.cnicBack = values.cnicBack[0].originFileObj;
    }
    if (values.licenseFront === undefined) {
      swalNotification(
        "Validation Error",
        "License Front Image is Required",
        "error"
      );
      return null;
    } else {
      values.licenseFront = values.licenseFront[0].originFileObj;
    }
    if (values.licenseBack === undefined) {
      swalNotification(
        "Validation Error",
        "License Back Image is Required",
        "error"
      );
      return null;
    } else {
      values.licenseBack = values.licenseBack[0].originFileObj;
    }

    // console.log("Received values of form: ", values);
    // return null;

    const headers = {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    };

    try {
      setMBtnLoading(true);
      const resp = await riderAdd(values, headers);
      // console.log("rider added", resp.data);
      if (resp.data.code == 200) {
        swalNotification("Rider Added", resp.data.message, "success");
        navigate("/rider");
      }
    } catch (error) {
      validationErrors(error);
    } finally {
      setMBtnLoading(false);
    }
  };
  const [state, setState] = useState({
    loading: false,
  });

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  const handleChange = (info) => {
    let fileList = [...info.fileList];

    if (info.file.status === "uploading") {
      setState({ loading: true });
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) =>
        setState({
          imageUrl,
          loading: false,
        })
      );
    }
  };

  function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      swalNotification(
        "File Type  JPG/PNG ",
        "You can only upload JPG/PNG file!",
        "error"
      );
      return null;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      // console.error("Image must smaller than 2MB!");
      swalNotification(
        "Image Size Issue",
        "Image must be smaller than 2MB!",
        "error"
      );
      return null;
    }
    return isJpgOrPng && isLt2M;
  }

  const uploadProfileImageButton = (
    <div>
      <div className="ant-upload-text">Upload Profile Image</div>
    </div>
  );

  const uploadFrontCNICButton = (
    <div>
      <div className="ant-upload-text">Upload Front CNIC</div>
    </div>
  );

  const uploadBackCNICButton = (
    <div>
      <div className="ant-upload-text">Upload Back CNIC</div>
    </div>
  );

  const uploadFrontLicenseButton = (
    <div>
      <div className="ant-upload-text">Upload Front License</div>
    </div>
  );

  const uploadBackLicenseButton = (
    <div>
      <div className="ant-upload-text">Upload Back License</div>
    </div>
  );

  const uploadFrontBillButton = (
    <div>
      <div className="ant-upload-text">Upload Front Bill</div>
    </div>
  );

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

const { imageUrl } = state;
  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>{pagename}</Title>
        </div>
        <div className="pch">
          <Button onClick={() => navigate("/rider")}>
            <RollbackOutlined />
          </Button>
        </div>
      </div>
      <div className="p-content">
        <Form name="validate_other" {...formItemLayout} onFinish={onFinish}>
          <div className="customTable">
            <table>
              {/* <thead>
          <tr>
            <th>Batch</th>
            <th>Slots percentage</th>
            <th>Show time</th>
            <th>Expiry Time</th>
          </tr>
        </thead> */}
              <tbody>
                <tr direction="horizontal" size={12}>
                  <td>
                    <Form.Item
                      name={"phoneNumber"}
                      rules={[
                        {
                          required: true,
                          message: "Your Phone Number is Required",
                        },
                        {
                          pattern: /^(\+92)[0-9]{10}$/,
                          message:
                            "+923000000000 Phone number format. 10 numbers add after +92 ",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Phone Number eg.+92**"
                        // minLength={13}
                        // maxLength={13}
                      />
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                      name={"fullName"}
                      rules={[
                        {
                          required: true,
                          message: "Your Full Name is Required",
                        },
                      ]}
                    >
                      <Input placeholder="Full Name" />
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                      name={"cnic"}
                      rules={[
                        {
                          required: true,
                          message: "Your CNIC number is required",
                          pattern: new RegExp(/^[0-9]+$/),
                        },
                        {
                          type: "number",
                          min: 1000000000000,
                          max: 9999999999999,
                          message: "Please enter your complete CNIC number",
                        },
                      ]}
                    >
                      <InputNumber placeholder="CNIC" />
                    </Form.Item>
                  </td>
                </tr>
                <tr direction="horizontal" size={12}>
                  <td>
                    <Form.Item
                      name={"email"}
                      rules={[
                        {
                          type: "email",
                          required: true,
                          message: "Email is Required",
                        },
                      ]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                      name={"vehicle"}
                      rules={[
                        {
                          required: true,
                          message: "Vehicle is Required",
                        },
                      ]}
                    >
                      <Select name={"vehicle"} placeholder="Select Vehicle">
                        <Option value="" disabled>
                          Select Vehicle
                        </Option>
                        <Option value="Bike">Bike</Option>
                        <Option value="Car">BiCycle</Option>
                      </Select>
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                      name={"city"}
                      rules={[
                        {
                          required: true,
                          message: "City is Required",
                        },
                      ]}
                    >
                      <Select name={"city"} placeholder="Select City">
                        <Option value="" disabled>
                          Select City
                        </Option>
                        <Option value="Karachi">Karachi</Option>
                        <Option value="Lahore">Lahore</Option>
                        <Option value="Rawalpindi">Rawalpindi</Option>
                      </Select>
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Form.Item
                      name={"password"}
                      rules={[
                        {
                          required: true,
                          message: "Your PassCode number is required",
                          pattern: new RegExp(/^[0-9]+$/),
                        },
                        {
                          type: "number",
                          min: 0,
                          max: 9999,
                          message: "Please enter your complete PassCode number",
                        },
                      ]}
                    >
                      <InputNumber placeholder="PassCode" />
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Form.Item
                      name="cnicFront"
                      valuePropName="fileList"
                      getValueFromEvent={normFile}
                    >
                      <Upload
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={true}
                        maxCount={1}
                        onPreview={onPreview}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt="avatar"
                            style={{ width: "100%" }}
                          />
                        ) : (
                          uploadFrontCNICButton
                        )}
                      </Upload>
                    </Form.Item>
                    <Form.Item
                      name="cnicBack"
                      valuePropName="fileList"
                      getValueFromEvent={normFile}
                    >
                      <Upload
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={true}
                        maxCount={1}
                        onPreview={onPreview}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt="avatar"
                            style={{ width: "100%" }}
                          />
                        ) : (
                          uploadBackCNICButton
                        )}
                      </Upload>
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                      name="licenseFront"
                      valuePropName="fileList"
                      getValueFromEvent={normFile}
                    >
                      <Upload
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={true}
                        maxCount={1}
                        onPreview={onPreview}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt="avatar"
                            style={{ width: "100%" }}
                          />
                        ) : (
                          uploadFrontLicenseButton
                        )}
                      </Upload>
                    </Form.Item>
                    <Form.Item
                      name="licenseBack"
                      valuePropName="fileList"
                      getValueFromEvent={normFile}
                    >
                      <Upload
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={true}
                        maxCount={1}
                        onPreview={onPreview}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt="avatar"
                            style={{ width: "100%" }}
                          />
                        ) : (
                          uploadBackLicenseButton
                        )}
                      </Upload>
                    </Form.Item>
                  </td>
                  <td>
                    <Form.Item
                      name="bill"
                      valuePropName="fileList"
                      getValueFromEvent={normFile}
                    >
                      <Upload
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={true}
                        maxCount={1}
                        onPreview={onPreview}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt="avatar"
                            style={{ width: "100%" }}
                          />
                        ) : (
                          uploadFrontBillButton
                        )}
                      </Upload>
                    </Form.Item>
                    {/* <Form.Item
                      name="profileImage"
                      valuePropName="fileList"
                      getValueFromEvent={normFile}
                    >
                      <Upload
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={true}
                        maxCount={1}
                        onPreview={onPreview}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt="avatar"
                            style={{ width: "100%" }}
                          />
                        ) : (
                          uploadProfileImageButton
                        )}
                      </Upload>
                    </Form.Item> */}
                  </td>
                </tr>
                <tr>
                  <td colSpan={3}>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={MBtnLoading}
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Form>
      </div>
    </div>
  );
};
export default RiderAdd;
